(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/active-suspension.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/active-suspension.js');
'use strict';

const SUSPENSION_PRODUCT_ID = svs.spelpaus.constants.SUSPENSION_PRODUCT_ID;
const _svs$spelpaus$pages$s = svs.spelpaus.pages.svsSuspension.components,
  ActiveAllSuspension = _svs$spelpaus$pages$s.ActiveAllSuspension,
  ActiveQuickGamesSuspension = _svs$spelpaus$pages$s.ActiveQuickGamesSuspension,
  ActiveVegasSuspension = _svs$spelpaus$pages$s.ActiveVegasSuspension;
const ActiveSuspension = _ref => {
  let suspension = _ref.suspension;
  switch (suspension.product) {
    case SUSPENSION_PRODUCT_ID.ALL:
      return React.createElement(ActiveAllSuspension, {
        suspension: suspension
      });
    case SUSPENSION_PRODUCT_ID.QUICKGAMES:
      return React.createElement(ActiveQuickGamesSuspension, {
        suspension: suspension
      });
    case SUSPENSION_PRODUCT_ID.VEGAS:
      return React.createElement(ActiveVegasSuspension, {
        suspension: suspension
      });
    default:
      return null;
  }
};
svs.spelpaus.pages.svsSuspension.components.ActiveSuspension = ActiveSuspension;

 })(window);